import {REBRAND_BASE_URL} from "../services/config";

type TLiveClassLinkPayload = {
  username: string;
  slug: string;
  eventId: string | number;
  tinyUrl?: string;
  windowNav?: boolean;
};
type TLiveClassSuccessLinkPayload = {
  username: string;
  slug: string;
  eventId: string | number;
  windowNav?: boolean;
};
type TLiveClassBookingLinkPayload = {
  username: string;
  slug: string;
  eventId: string;
};

export function handleLiveClassLink({
  eventId,
  slug,
  username,
  tinyUrl,
  windowNav,
}: TLiveClassLinkPayload) {
  // if (windowNav) {
  const link = tinyUrl
    ? `${REBRAND_BASE_URL}/${username}/${tinyUrl}`
    : `${REBRAND_BASE_URL}/${username}/event/${slug}?id=${eventId}`;
  return link;
  // } else {
  //   return baseLink;
  // }
}
export function handleLiveClassBookingLink({
  eventId,
  slug,
  username,
}: TLiveClassBookingLinkPayload) {
  const link = `/${username}/live-classes/details/booking?slug=${slug}&eventId=${eventId}`;

  return link;
}

export function handleLiveClassSuccessBookingLink({
  eventId,
  slug,
  username,
  windowNav,
}: TLiveClassSuccessLinkPayload) {
  // const baseLink = `/${username}/live-classes/booking/success?slug=${slug}&eventId=${eventId}`;

  // if (windowNav) {
  const link = `${REBRAND_BASE_URL}/${username}/event/${slug}/success?id=${eventId}`;
  return link;
  // } else {
  //   return baseLink;
  // }
}
